export default __webpack_public_path__ + "static/media/Patrick2_BW.ae23c7ef.jpg";